import { AnnouncementHttp } from '@/services';
import { getUniversityKey } from '@/services/http';
import { parseError } from '@/utils';
import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export interface AnnouncementStore {
  uniKey: string;
  loading: boolean;
  loaded: boolean;
  error: string;
  fetchTime: number;
  total: number;
  announcements: AnnouncementEntity[];
}

export interface AnnouncementStoreAction {
  fetchAnnouncements: () => Promise<AnnouncementEntity[]>;
}

export type AnnouncementStoreState = AnnouncementStore & AnnouncementStoreAction;

const REFETCH_TIME = 1000 * 30 * 60;

export const useAnnouncementStore = create(
  persist<AnnouncementStore & AnnouncementStoreAction>((set, get) => ({
    uniKey: getUniversityKey(),
    announcements: [],
    loaded: false,
    loading: false,
    fetchTime: 0,
    total: 0,
    error: null,
    fetchAnnouncements: async () => {
      const uniKey = getUniversityKey();
      if (uniKey == null) return;
      const state = get();
      const diff = Math.abs(state.fetchTime - Date.now());
      if (state.uniKey == uniKey && diff < REFETCH_TIME) {
        if (!state.loaded) {
          set({ loaded: true });
        }
        return state.announcements ?? [];
      };
      set({ loading: true, announcements: [] });
      try {
        const response = await AnnouncementHttp.list();
        const content = response?.data?.payload?.content ?? [];
        const total = response?.data?.payload?.totalElements;
        set({ announcements: content, fetchTime: Date.now(), total, loading: false, error: null, uniKey, loaded: true });
        return state.announcements ?? [];
      }
      catch (e) {
        set({ error: parseError(e), loading: false, announcements: [], loaded: true })
        return [];
      }
    },
  }), {
    partialize: (state) => {
      return Object.fromEntries(
        Object.entries(state).filter(([key]) => !['loading', 'loaded', 'erorr'].includes(key)),
      ) as AnnouncementStoreState;
    },
    name: 'announcements-storage',
    storage: createJSONStorage(() => localStorage)
  })
);

setTimeout(() => {
  useAnnouncementStore.getState().fetchAnnouncements();
}, 2000);

export default useAnnouncementStore;
